<div *ngIf="listOfAddresses.length > 0 && !addAddress && !editAddress">
  <p class="nome-produto">Selecione o endereço:</p>


  <ion-radio-group [allowEmptySelection]="true" (ionChange)="touchSelectAddress($event)">
    <div *ngFor="let item of listOfAddresses">

      <ion-item-sliding class="custom-sliding" >
        <ion-item-options side="start" (click)="touchEditAddress(item)">
          <ion-item-option color="success">Editar</ion-item-option>
        </ion-item-options>
        <ion-item class="form-endereco margin5" lines="none" [ngClass]="{'item-selected': item.id == formAddress.id}">
          <ion-radio labelPlacement="end" [value]="item"><b>{{ item.street }}</b></ion-radio>
          <p>{{ item.number }} - {{ item.complement }} - {{ item.district }} - {{ item.zipcode }} - {{
            item.city }} - {{ item.state }}</p>
        </ion-item>
        <ion-item-options side="end" (click)="touchDeleteAddress(item)">
          <ion-item-option color="danger">Excluir</ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    </div>
  </ion-radio-group>


  <ion-row>
    <ion-col>
      <ion-button class="btn-padrao" expand="block" color="success" (click)="touchAddNewAddress()">
        Novo Endereço
      </ion-button>
    </ion-col>
    <ion-col>
      <ion-button [disabled]="!isValidForm()" class="btn-padrao" expand="block" color="primary" (click)="touchConfirm()">
        Continuar
      </ion-button>
    </ion-col>
  </ion-row>


</div>

<form [formGroup]="formRescue" *ngIf="addAddress || editAddress">
  <p class="nome-produto">Preencha os dados do endereço</p>

  <ion-item lines="none" class="form-endereco margin5">
    <ion-input labelPlacement="floating" label="CEP" type="text" inputmode="numeric" minlength="8" maxlength="9"
      appMask="*****-***" (keyup)="getAddressByCep()" [(ngModel)]="formAddress.zipcode" formControlName="zipcode">
    </ion-input>
  </ion-item>

  <ion-item lines="none" class="form-endereco margin5">
    <ion-input labelPlacement="floating" label="ENDEREÇO" [(ngModel)]="formAddress.street" formControlName="street">
    </ion-input>
  </ion-item>

  <ion-item lines="none" class="form-endereco margin5">
    <ion-input labelPlacement="floating" label="NÚMERO" type="text" inputmode="numeric" maxlength="10"
      [(ngModel)]="formAddress.number" appRemoveFromInput="letter" formControlName="number">
    </ion-input>
  </ion-item>

  <ion-item lines="none" class="form-endereco margin5">
    <ion-input labelPlacement="floating" label="COMPLEMENTO" maxlength="20" [(ngModel)]="formAddress.complement"
      formControlName="complement">
    </ion-input>
  </ion-item>

  <ion-item lines="none" class="form-endereco margin5">
    <ion-input labelPlacement="floating" label="BAIRRO" [(ngModel)]="formAddress.district" formControlName="district">
    </ion-input>
  </ion-item>

  <ion-row>
    <ion-col size="8">
      <ion-item lines="none" class="form-endereco">
        <ion-input labelPlacement="floating" label="CIDADE" [(ngModel)]="formAddress.city" formControlName="city">
        </ion-input>
      </ion-item>
    </ion-col>
    <ion-col size="4">
      <ion-item lines="none" class="form-endereco">
        <ion-select labelPlacement="floating" label="ESTADO" ok-text="OK" cancel-text="Cancelar"
          [(ngModel)]="formAddress.state" formControlName="state">
          <ion-select-option *ngFor="let item of utilService.listOfStates" [value]="item">{{item}}</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col>
  </ion-row>

  <ion-item lines="none" class="form-endereco margin5">
    <ion-input labelPlacement="floating" label="REFERÊNCIA" [(ngModel)]="formAddress.reference"
      formControlName="reference" maxlength="20">
    </ion-input>
  </ion-item>

  <ion-row>
    <ion-col size="6">
      <ion-button *ngIf="listOfAddresses.length > 0" color="primary" expand="block" class="btn-padrao" (click)="touchBackToList()">
        Voltar a lista
      </ion-button>
    </ion-col>

    <ion-col size="6">
      <ion-button [disabled]="!isValidForm()" color="success" expand="block" class="btn-padrao" (click)="touchSaveAddress()">
        Salvar Endereço
      </ion-button>
    </ion-col>
  </ion-row>

</form>
